import React, { useRef } from "react";
import classNames from "classnames";
import ss from "./HostCard.module.css";
import { Confirm } from "../confirm/confirm";
import { apiRequest, showAlert, showLoading } from "../../utils";

export default function HostCard(props) {
  const { data = false, clone, go_ready, index, total } = props;

  const clock = () => {
    if (data) {
      go_ready(data.uuid);
    } else {
      clone();
    }
  };

  // 长按清理场次
  const longTapTimer = useRef(null);
  const handleTouchStart = () => {
    longTapTimer.current = setTimeout(() => {
      // 长按事件的逻辑
      Confirm.show("请确认是否清理该场次", () => {
        const loading = showLoading("加载中");
        apiRequest("/close_game_session", "POST", { session_uuid: data.uuid })
          .then((res) => {
            if (res.code === 0) {
              clone();
            } else {
              showAlert(res.msg);
            }
          })
          .catch((err) => showAlert("请求失败，请稍后重试", err.message))
          .finally(() => {
            loading.hide();
          });
      });
    }, 1500); // 这里定义长按的时间阈值，单位为毫秒
  };
  const handleTouchEnd = () => {
    clearTimeout(longTapTimer.current);
  };

  return (
    <div
      className={classNames(
        ss.card_box,
        data.status >= 200 && ss.gray,
        !data && ss.create
      )}
      onClick={() => {
        clock();
      }}
      onTouchStart={() => {
        if (data.status >= 200) handleTouchStart();
      }}
      onTouchEnd={handleTouchEnd}
    >
      {!data && <div className={ss.new_game}></div>}
      {data && (
        <>
          <div className={ss.title}>
            <span>{data.name}</span>
          </div>
          <div className={ss.data}>
            <div className={ss.data_value}>
              队伍数量：{data.team_colors.split(",").length}
            </div>
            <div className={ss.data_value}>游戏时长：{data.duration}分钟</div>
            <div className={ss.data_value}>地图：{data.map_name}</div>
            <div className={ss.data_value}>
              升级难度：{data.upgrade_condition}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
